import request from "@/utils/request";

export function getPriceConfig() {
  return request({
    method: "get",
    url: "/frontend",
  });
}

export function getUsageCharge(data) {
  return request({
    method: "post",
    url: "/subscriptions/usage/charge",
    data,
  });
}

export function upgradePlan(data) {
  return request({
    method: "post",
    url: "/subscriptions/upgrade",
    data,
  });
}

export function estimateUpgrade(data, option = {}) {
  return request({
    method: "post",
    url: "/subscriptions/upgrade/estimate",
    data,
    ...option,
  });
}

export function getSubscriptions(data) {
  return request({
    method: "post",
    url: "/subscriptions",
    data,
  });
}

export function getCurrenices() {
  return request({
    method: "get",
    url: "/currencies",
  });
}

export function getFailureCharges(data) {
  return request({
    method: "post",
    url: "/billing/failure_charges",
    data,
  });
}

export function subscriptionsCharge(data) {
  return request({
    method: "post",
    url: "/subscriptions/charge",
    data,
  });
}
